export default __webpack_public_path__ + "static/media/calendar.5069dd54.svg";